module.exports = __webpack_public_path__ + "img/linse_samlet_raa_mange.4a07e87e.jpg";